import { FC } from "react";

interface ModuleItemProps {
    image: string
    title: string
    description: string
}

const ModuleItem: FC<ModuleItemProps> = ({ image, title, description }) => {
    return (
        <div className="col-12 col-lg-4">
            <div className="card border-0 rounded-5 bg-white p-4 h-100">
                <div className="card-body text-start">
                    <img src={`/assets/icons/${image}.png`} alt="" className="img-fluid" />
                    <h4 className="fw-bold mt-5">{title}</h4>
                    <p>
                        {description}
                    </p>
                </div>
            </div>
        </div>
    )
}

export { ModuleItem }